export const AI_ASSISTANT_SIDEBAR_WIDTH = 120;
